import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import dataModel from '../../models/DataModel';
import Animate from '../../components/Animate';
import './QuickCompleteSlideout.scss';
import Hammer from 'hammerjs';

class QuickCompleteSlideout extends BaseComponent {
  constructor(props) {
    super(props);
    
    this.animationInProgress = false;
    this.id = props.id || Math.ceil(Math.random() * 10000);
    
    this.leftStart = window.innerWidth - 34;
    this.state = { 
      animateResize: null,
      teaserAnimation: false,
      unwindTeaserAnimation: false,
      componentAnimation: false,
      unwindComponentAnimation: false,
      left: this.leftStart,
      width: null,
    };
  }

  componentDidMount() {
    const { currentUser, firstInList } = this.props; 
    const self = this;
    const userSettings = currentUser.settings;
    if (
        firstInList && userSettings && 
        (!userSettings.ui_features || !userSettings.ui_features.dont_bounce_quick_actions) 
    ) {
      setTimeout(() => {
        self.setState({ teaserAnimation: true });
      }, 800);
    }

    setTimeout(() => {
      self.handleSettings();
    }, 100);
  }

  componentDidUpdate(prevProps){
    if (prevProps.completionStep != this.props.completionStep && this.componentLeft && this.state.left != this.leftStart) {
      // pause before resizing
      this.props.handleIsQuickActionAnimating(true);
      const self = this;
      setTimeout(() => {
        const prevLeft = self.componentLeft;
        const prevWidth = self.contentWidth;
        self.handleSettings(true);
        setTimeout(() => {
          this.props.handleIsQuickActionAnimating(false);
        }, 500);
        if (prevWidth != self.contentWidth) {
          self.setState({ animateResize: { prevLeft, prevWidth } });
        }
        else {
          self.setState({ left: this.componentLeft });
        }
      }, 500);
    }
    if (prevProps.swipeDirection != this.props.swipeDirection) {
      this.props.handleIsQuickActionAnimating(true);
      this.setState({ swipeDirection: this.props.swipeDirection });
      this.handleSlideoutSwipe(this.props.swipeDirection);
    }
  }

  handleSettings(resize) {
    if (!this.componentLeft || resize) {
      this.leftStart = window.innerWidth - 34;
      this.teaserLeft = this.leftStart - 50;
      const element = document.getElementById(this.id);
      if (element) {
        const elements = element.getElementsByClassName('quick-action-button');
        if (elements && elements.length > 0) {
          let contentWidth = elements.length * 58;
          this.componentLeft = this.leftStart - contentWidth;
          this.setState({
            left: this.leftStart,
            width: this.contentWidth,
          });
        }
        else {
          const elements = element.getElementsByClassName('no-action-container');
          if (elements && elements.length > 0) {
            const contentWidth = 298;
            this.componentLeft = this.leftStart - contentWidth;
            this.setState({
              left: this.leftStart,
              width: this.contentWidth,
            });
          }
        }
      }
    }
  }

  handleItemsInPlace(refElement) {
    if (refElement && !this.refElement) {
      this.refElement = refElement;
      this.handleSettings();
    }
  }

  handleTeaserAnimationDone() {
    if (this.state.teaserAnimation) {
      const self = this;
      setTimeout(() => {
        self.animationInProgress = false;
        self.setState({ teaserAnimation: false, unwindTeaserAnimation: true, left: this.teaserLeft });
        this.props.handleIsQuickActionAnimating(false);
      }, 250);
    }
    else {
      this.animationInProgress = false;
      this.setState({ unwindTeaserAnimation: false, left: this.leftStart });
    }
  }

  handleComponentAnimationInDone() {
    this.animationInProgress = false;
    if (this.props.handleExpand) {
      this.props.handleExpand(this.props.completionStep);
    }
    this.setState({ componentAnimation: false, left: this.componentLeft, animateResize: null });
    setTimeout(() => {
      if (this.props.handleIsQuickActionAnimating) {
        this.props.handleIsQuickActionAnimating(false);
      }
    }, 250);
  }

  handleAnimateResizeDone() {
    this.animationInProgress = false;
    this.setState({ left: this.componentLeft, animateResize: null, componentAnimation: false });
    setTimeout(() => {
      if (this.props.handleIsQuickActionAnimating) {
        this.props.handleIsQuickActionAnimating(false);
      }
    }, 250);
  }

  handleComponentAnimationOutDone() {
    this.animationInProgress = false;
    this.setState({ unwindComponentAnimation: false, left: this.leftStart });
    setTimeout(() => {
      if (this.props.handleIsQuickActionAnimating) {
        this.props.handleIsQuickActionAnimating(false);
      }
    }, 250);
  }

  handleSlideoutSwipe(direction) {
    const currentUser = Object.assign({}, this.props.currentUser);

    if (this.state.left == this.leftStart && direction == Hammer.DIRECTION_LEFT) {
      const userSettings = currentUser.settings;
      if (userSettings && (!userSettings.ui_features || !userSettings.ui_features.dont_bounce_quick_actions)) {
        if (!userSettings.ui_features) {
          userSettings.ui_features = {};
        }
        userSettings.ui_features.dont_bounce_quick_actions = true;
        // using dataModel as it handles currentUser, we need to refactor this
        dataModel.usersDAO.updateUser(currentUser);
      }
      this.setState({ componentAnimation: true });
    }
    else if (this.state.left != this.leftStart && direction == Hammer.DIRECTION_RIGHT)  {
      this.setState({ unwindComponentAnimation: true });
    }
  }

  createAnimation() {
    let animation = null;
    if (this.state.teaserAnimation && !this.animationInProgress) {
      this.props.handleIsQuickActionAnimating(true);
      this.animationInProgress = true;
      animation = (
        <Animate 
          component_id={'quick-complete-slideout-' + this.id}
          key={'quick-complete-teaser-slideout-in' + this.id}
          duration={500} 
          property={{ left: { startVal: this.leftStart, endVal: this.teaserLeft } }} 
          completionCallback={this.handleTeaserAnimationDone}
        />
      );
    }
    if (this.state.unwindTeaserAnimation && !this.animationInProgress) {
      this.props.handleIsQuickActionAnimating(true);
      this.animationInProgress = true;
      animation = (
        <Animate 
          component_id={'quick-complete-slideout-' + this.id}
          key={'quick-complete-teaser-slideout-out' + this.id}
          duration={1000} 
          property={{ left: { startVal: this.teaserLeft, endVal: this.leftStart } }} 
          completionCallback={this.handleTeaserAnimationDone}
        />
      );
    }

    if (this.state.componentAnimation && !this.animationInProgress) {
      this.props.handleIsQuickActionAnimating(true);
      this.animationInProgress = true;
      animation = (
        <Animate 
          component_id={'quick-complete-slideout-' + this.id}
          key={'quick-complete-slideout-in' + this.id}
          duration={500} 
          property={{ left: { startVal: this.leftStart, endVal: this.componentLeft } }} 
          completionCallback={this.handleComponentAnimationInDone}
        />
      );
    }

    if (this.state.unwindComponentAnimation && !this.animationInProgress) {
      this.props.handleIsQuickActionAnimating(true);
      animation = (
        <Animate 
          component_id={'quick-complete-slideout-' + this.id}
          key={'quick-complete-slideout-out' + this.id}
          duration={500} 
          property={{ left: { startVal: this.componentLeft, endVal: this.leftStart } }} 
          completionCallback={this.handleComponentAnimationOutDone}
        />
      );
    }
    if (this.state.animateResize && this.state.left != this.leftStart) {
      this.props.handleIsQuickActionAnimating(true);
      this.animationInProgress = true;
      animation = (
        <Animate 
          component_id={'quick-complete-slideout-' + this.id}
          key={'quick-complete-slideout-in' + this.id}
          duration={500} 
          property={{ left: { startVal: this.state.animateResize.prevLeft, endVal: this.componentLeft } }} 
          completionCallback={this.handleAnimateResizeDone}
        />
      );
    }
    return animation;
  }

  render() {
    let style = !this.animationInProgress ? { left: this.state.left ? this.state.left : this.leftStart, width: this.state.width } : { left: this.leftStart, width: this.state.width };

    const animation = this.createAnimation();

    const content = <div className="no-action-container">
        <div className="text-line">This Completion Step can only be completed at</div>
        <div className="text-line">AO.finalze.com from your desktop computer.</div>
      </div>;
    
    return (
      <div id={this.id} className="quick-complete-slideout-container" key={'quick-action-' + this.id} ref={element => { this.handleItemsInPlace(element); }}>
        <div id={'quick-complete-slideout-' + this.id} className="quick-complete-slideout"
          style={style}>
          {animation}
          <div className="slideout-handle"/>
            {this.props.children || content}
        </div>
      </div>
    );
  }
}

export default QuickCompleteSlideout;



// WEBPACK FOOTER //
// ./src/components/QuickCompleteSlideout/index.js